

























import { Component, Vue } from "vue-property-decorator";
import SalonService from "@/services/SalonService";
import { Salon } from "@/models/salon";

@Component
export default class QrRedirectApp extends Vue {
  salon_id = "";
  salon_detail_url = "";
  salon: Salon = new Salon();
  token_false = false
  public async created() {
    this.salon_id = String(this.$route.params.salon_id);
    const response = await SalonService.redirectQr({
      salon_id: this.salon_id
    });
    if (response.data.salons && response.data.token !== undefined) {
      this.$router.push({ name: "SecretServiceList", params: {secret_sale_token: response.data.token} });

    } else if (response.data.salons && response.data.token === undefined ) {
      this.token_false = true;
      this.salon = response.data.salons
      this.salon_detail_url = process.env.VUE_APP_SALON_ENDPOINT + 'mypage/service'
      this.$store.dispatch("actionSetHeaderUrl", this.salon.image_logo_url);
      this.$store.dispatch("actionSetSalonName", this.salon.salon_name);
    } else {
      this.$router.push({ name: "NotFound" });
    }
  }

  goSalonService(){
    window.open(this.salon_detail_url, "_blank");
  }
}
